import m from 'mithril'
import {t} from 'store'
import {Component} from '@codeurs/front'
import Button from 'views/layout/button'
import Wysiwyg from 'views/layout/wysiwyg'

import './popup.less'

export default class Popup extends Component<{
	desc: string
	close: Function
}> {
	view() {
		return m('.popup', [this.viewClose(), this.viewContent()])
	}

	viewContent() {
		const {desc} = this.attrs
		return m('.popup-content', [desc && m(Wysiwyg, {html: desc})])
	}

	viewClose() {
		const {close} = this.attrs
		return m('.popup-close', [m(Button, {onclick: close}, t('close'))])
	}
}
